import Address from "./address";
import Location from "./location";
import Subscription from "./subscription";

export default class Account {
  public idAccount: number = 0;
  public accountName: string = "";
  public accountCode: string = "";
  public serviceInstructions: string = "";
  public locations: Location[] = [];
  public subscriptions: Subscription[] = [];
  public billingAddress: Address = new Address();
  public shippingAddress: Address = new Address();
  public isShippingSameAsBillingAddress: boolean = true;
  public currency: string = "";
  public email: string = "";
  public phone: string = "";
  public billingDepartmentEmail: string = "";
}
